import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NotificationsService } from 'app/services/notifications.service';
import { UserService } from 'app/services/user.service';
import { MemedService } from 'modules/promptuary/services/memed/memed.service';

@Component({
	selector: 'create-memed-dialog',
	templateUrl: 'create-memed-dialog.component.html',
	styleUrls: ['create-memed-dialog.component.scss'],
})
export class CreateMemedDialog {
	@Input() isOpen = false;
	@Output() close = new EventEmitter<any>();
	@Output() create = new EventEmitter<any>();
	hasError = false;
	constructor(
		public userService: UserService,
		public notificationService: NotificationsService,
		public translateService: TranslateService,
		public memedService: MemedService
	) {}

	async createMemedAccount() {
		if (await this.checkEssentialInfo()) {
			this.close.emit();
			return;
		}
		this.memedService
			.createUser()
			.toPromise()
			.then(() => {
				this.create.emit();
			})
			.catch(({ error }) => {
				this.notificationService.showError(error.message);
			});
	}

	async checkEssentialInfo() {
		const needAtention = [];
		const memedEssential = [
			'firstName',
			'lastName',
			'birthdate',
			'fiscalId',
			'medicalLicense',
		];

		const userData = await this.userService.getProfileData();

		memedEssential.forEach((essentialInfo) => {
			if (!userData.hasOwnProperty(essentialInfo) || !userData[essentialInfo]) {
				needAtention.push(essentialInfo);
			}
		});

		if (needAtention.length > 0) {
			this.hasError = true;
			return this.notificationService.showError(
				this.translateService.instant('PROMPTUARY.ERRORS.INVALID_DATA')
			);
		}

		return this.hasError;
	}
}
